export const slugify = (text?: string) => {
  if (!text) return "unknown";
  return text.toLowerCase().trim().replace(/\s+/g, '-');
};

export const formatSlugUpperCase = (slug?: string) => {
  if (!slug) return "unknown";
  return slug.replace(/-/g, " ").toUpperCase();
};

export const formatSlug = (slug: string) => {
  return slug
    .split("-")
    .map(word => word.toUpperCase() === word ? word : word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
